import { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useUserPreference } from '../contexts/UserPreferenceContext';

const VALID = ['light', 'dark', 'system'];

/**
 * Ponte servidor → tema: quando as preferências do usuário carregam
 * (login/refresh), aplica o tema salvo em `user_preferences` no ThemeContext.
 * O sentido inverso (ao clicar no toggle) é persistido pelo próprio ThemeToggle,
 * então não há loop — este efeito só reage a mudanças do valor vindo do servidor.
 */
export const ThemeSync = () => {
  const { setPreference } = useTheme();
  const { preference } = useUserPreference();
  const serverTheme = preference?.theme;

  useEffect(() => {
    if (serverTheme && VALID.includes(serverTheme)) {
      setPreference(serverTheme);
    }
  }, [serverTheme, setPreference]);

  return null;
};

export default ThemeSync;
